/**
 * Shared outcome resolution for interactive tool cards. Precedence: this
 * session's click (local), the part-text annotation (partText), the durable
 * ExternalAction status (action). 2-tier cards simply omit `action`.
 */
import { useMemo } from "react";

import { useChatStreamValue } from "src/reusable/Chat/ChatStreaming/hooks/useChatStream";
import { hasLaterUserMessage } from "./toolStatusUtils";

export function resolveOutcome<T>({
  local,
  partText,
  action,
}: {
  local: T | null | undefined;
  partText?: T | null | undefined;
  action?: T | null | undefined;
}): T | null {
  return local ?? partText ?? action ?? null;
}

const EMPTY_DIALOGUE: Array<{ id?: string; type?: string }> = [];

/** True when the user answered a still-open prompt in plain text (later User message). */
export function useStaleUnanswered(messageId: string | undefined): boolean {
  const dialogue = useChatStreamValue((s) => s.dialogue, EMPTY_DIALOGUE);
  return useMemo(
    () => hasLaterUserMessage(dialogue, messageId),
    [dialogue, messageId],
  );
}
